export default "__VITE_ASSET__17b3dd54__"